import React, {useState, useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/contact-breadcrumb.webp'
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecaptcha } from "../Components/ReCaptcha";
import SchemaMarkup from "../Components/SchemaMarkup";
import WebPageSchema from "../Schema/webPageSchema";
import createBreadcrumbSchema from "../Schema/breadcrumbSchema";

const Contact=()=>{
     useEffect(() => {
        document.title =
          "Contact Gurukrupa Wood Pvt. Ltd.";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Contact Gurukrupa Wood Pvt. Ltd. for wooden pallets, boxes, crates & customised industrial packaging solutions."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://gurukrupawood.com/contact-us");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "Contact Gurukrupa Wood Pvt. Ltd."
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Contact Gurukrupa Wood Pvt. Ltd. for wooden pallets, boxes, crates & customised industrial packaging solutions."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://gurukrupawood.com/contact-us");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://gurukrupawood.com/contact.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "Contact Gurukrupa Wood Pvt. Ltd."
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Contact Gurukrupa Wood Pvt. Ltd. for wooden pallets, boxes, crates & customised industrial packaging solutions."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://gurukrupawood.com/contact.webp"
        );
      }
      }, []);

const [formData, setFormData] = useState({
  name: "",
  companyName: "",
  phoneNumber:"",
  email: "",
  subject: "",
  message: ""
});
const [loading, setLoading] = useState(false);
const generateToken = useRecaptcha();


const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value
  }));
};
    
const handleSubmit = async (e) => {

  e.preventDefault();

  if (!formData.name)
    return toast.error("Please enter your name");

  if (!formData.companyName)
    return toast.error("Please enter your Company Name");

  if (!formData.phoneNumber)
    return toast.error("Please enter phone number");

  if (!formData.email)
    return toast.error("Please enter email");

  if (!formData.subject)
    return toast.error("Please enter subject");

  if (!formData.message)
    return toast.error("Please enter message");

  const phoneRegex = /^[0-9]{10}$/;

  if (!phoneRegex.test(formData.phoneNumber)) {
    return toast.error(
      "Enter valid 10 digit phone number"
    );
  }

  setLoading(true);

  // ✅ GENERATE RECAPTCHA TOKEN
  generateToken(async (token) => {

    try {

      // ✅ VERIFY RECAPTCHA
      const recaptchaData = new FormData();

      recaptchaData.append(
        "secret",
        "6Le5nwAtAAAAABU2cKd_70tScz22RlaOz_yAfIVh"
      );

      recaptchaData.append(
        "response",
        token
      );

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      console.log(
        "FULL RESPONSE:",
        verifyRes.data
      );

      const score =
        verifyRes.data.score ||
        verifyRes.data.data?.score;

      console.log(
        "Recaptcha Score:",
        score
      );

      // ✅ BLOCK SPAM
      if (!score || score <= 0.5) {

        toast.error(
          "Spam detected. Please try again."
        );

        setLoading(false);

        return;
      }

      // ✅ EMAIL TEMPLATE
      const template = `
<div style="margin:0; padding:40px 0; background:#f4f7f6; font-family:Montserrat, Arial, sans-serif;">

  <table width="100%" cellpadding="0" cellspacing="0" border="0">
    <tr>
      <td align="center">

        <!-- MAIN CARD -->
        <table 
          width="620" 
          cellpadding="0" 
          cellspacing="0" 
          border="0"
          style="
            background:#ffffff;
            border-radius:18px;
            overflow:hidden;
            box-shadow:0 12px 40px rgba(0,0,0,0.08);
          "
        >

          <!-- TOP STRIP -->
          <tr>
            <td
              style="
                height:8px;
                background:linear-gradient(90deg,#3E2101,#006257);
              "
            ></td>
          </tr>

          <!-- HEADER -->
          <tr>
            <td
              style="
                background:#DFF4F2;
                padding:40px 40px 30px;
                text-align:center;
                border-bottom:1px solid #d6ebe8;
              "
            >
             <img 
                src='https://gurukrupawood.com/logo.png'
                alt='Gurukrupa Wood Pvt. Ltd.'
                style='max-width:170px; margin-bottom:20px;'
              />
         

              <h2
                style="
                  margin:0;
                  font-size:28px;
                  color:#3E2101;
                  font-weight:700;
                  letter-spacing:0.3px;
                "
              >
                New Contact Form Inquiry
              </h2>

              <p
                style="
                  margin:12px 0 0;
                  color:#4b4b4b;
                  font-size:15px;
                  line-height:1.7;
                "
              >
                A new enquiry has been submitted through the Gurukrupa Wood website.
              </p>

            </td>
          </tr>

          <!-- BODY -->
          <tr>
            <td style="padding:40px;">

              <table width="100%" cellpadding="0" cellspacing="0">

                <tr>
                  <td
                    style="
                      padding-bottom:18px;
                    "
                  >
                    <h3
                      style="
                        margin:0;
                        font-size:20px;
                        color:#006257;
                        font-weight:700;
                      "
                    >
                      Customer Details
                    </h3>
                  </td>
                </tr>

              </table>

              <table
                width="100%"
                cellpadding="0"
                cellspacing="0"
                style="
                  background:#fafafa;
                  border:1px solid #ececec;
                  border-radius:14px;
                  overflow:hidden;
                "
              >

                <tr>
                  <td
                    style="
                      padding:18px 22px;
                      border-bottom:1px solid #ececec;
                    "
                  >
                    <span style="color:#777;">Full Name</span><br/>
                    <strong style="color:#25180D; font-size:15px;">
                      ${formData.name}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td
                    style="
                      padding:18px 22px;
                      border-bottom:1px solid #ececec;
                    "
                  >
                    <span style="color:#777;">Phone Number</span><br/>
                    <strong style="color:#25180D; font-size:15px;">
                      ${formData.phoneNumber}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td
                    style="
                      padding:18px 22px;
                      border-bottom:1px solid #ececec;
                    "
                  >
                    <span style="color:#777;">Email Address</span><br/>
                    <strong style="color:#25180D; font-size:15px;">
                      ${formData.email}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td
                    style="
                      padding:18px 22px;
                      border-bottom:1px solid #ececec;
                    "
                  >
                    <span style="color:#777;">Company Name</span><br/>
                    <strong style="color:#25180D; font-size:15px;">
                      ${formData.companyName}
                    </strong>
                  </td>
                </tr>

                <tr>
                  <td
                    style="
                      padding:18px 22px;
                    "
                  >
                    <span style="color:#777;">Subject</span><br/>
                    <strong style="color:#25180D; font-size:15px;">
                      ${formData.subject}
                    </strong>
                  </td>
                </tr>

              </table>

              <div style="margin-top:35px;">

                <h3
                  style="
                    margin:0 0 18px;
                    font-size:20px;
                    color:#006257;
                    font-weight:700;
                  "
                >
                  Message
                </h3>

                <div
                  style="
                    background:#fafafa;
                    border:1px solid #ececec;
                    border-radius:14px;
                    padding:24px;
                    color:#25180D;
                    font-size:15px;
                    line-height:1.9;
                  "
                >
                  ${formData.message}
                </div>

              </div>

            </td>
          </tr>

          <tr>
            <td
              style="
                background:#3E2101;
                padding:24px;
                text-align:center;
              "
            >

              <p
                style="
                  margin:0;
                  color:#ffffff;
                  font-size:13px;
                  letter-spacing:0.3px;
                  line-height:1.7;
                "
              >
                Gurukrupa Wood Pvt. Ltd.<br/>
                Premium Industrial Wooden Packaging Solutions
              </p>

            </td>
          </tr>

        </table>

      </td>
    </tr>
  </table>

</div>
`;

      // ✅ SEND MAIL
      const data = new FormData();

      data.append(
        "title",
        "Gurukrupa Website Contact Form"
      );

      data.append(
        "to_email",
        "jignesh@gurukrupawood.com"
      );

      data.append(
        "cc",
        "arkayappsseo@gmail.com, sales@arkayapps.com"
      );

      data.append(
        "subject",
        "Gurukrupa : New Contact Lead"
      );

      data.append(
        "template",
        template
      );

      await axios.post(
        "https://api.sendmail.adhyaynam.in/send-mail/two",
        data,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      toast.success(
        "Query sent successfully 🚀"
      );

      // ✅ RESET
      setFormData({
        name: "",
        companyName: "",
        phoneNumber: "",
        email: "",
        subject: "",
        message: "",
      });

    } catch (error) {

      console.log(
        error.response?.data || error
      );

      toast.error(
        "Verification failed. Please try again!"
      );

    } finally {

      setLoading(false);

    }

  });

};

const schema = WebPageSchema({
    name: "Contact Gurukrupa Wood Pvt. Ltd.",
    url: "https://gurukrupawood.com/contact",
    description:
      "Contact Gurukrupa Wood Pvt. Ltd. for wooden packaging and export packaging requirements.",
    type: "ContactPage"
  });

  const breadcrumbSchema = createBreadcrumbSchema([
  {
    name: "Home",
    url: "https://gurukrupawood.com/"
  },
  {
    name: "Contact Us",
    url: "https://gurukrupawood.com/contact-us"
  },
]);
    return(
        <>

        <SchemaMarkup data={schema} />
        <SchemaMarkup data={breadcrumbSchema} />

           <Breadcrumb
  pageName="Contact Us"
  bgImage={bgImg}
/>

        {/**CONTACT FORM SECTION */}
       <section className="contact-main-section">

  <div className="container">

    <div className="contact-grid">

      {/* LEFT */}
      <motion.div
        className="contact-left"
        initial={{ opacity: 0, x: -70 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{
          duration: 0.9,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{ once: true, amount: 0.2 }}
      >

        {/* SUBHEADING */}
        <motion.h3
          className="section-subheading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          CONTACT US
        </motion.h3>

        {/* HEADING */}
        <motion.h2
          className="section-heading"
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.15,
            duration: 0.75,
          }}
          viewport={{ once: true }}
        >
          Let’s Connect
        </motion.h2>

        {/* TEXT */}
        <motion.p
          className="section-text contact-desc"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.3,
            duration: 0.7,
          }}
          viewport={{ once: true }}
        >
          Reach out to us for any inquiries,
          Quotations, or Support. We will get
          back to you as soon as possible.
        </motion.p>

        {/* CONTACT INFO */}
        <motion.div
          className="contact-info-wrapper"
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.14,
              },
            },
          }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >

          {[
            {
              icon: <FaPhoneAlt />,
              title: "Call us",
              content: (
                <a href="tel:+919624065081" className="section-text">
                  +91 96240 65081
                </a>
              ),
            },
            {
              icon: <FaEnvelope />,
              title: "Email us",
              content: (
                <a href="mailto:gurukrupagj@gmail.com" className="section-text">
                  gurukrupagj@gmail.com
                </a>
              ),
            },
            {
              icon: <FaMapMarkerAlt />,
              title: "Address",
              content: (
                <p className="section-text">
                  Survey No. 674/2, Ajapar - Tappar
                  Road, Vill. Bhimasar, Ta. Anjar,
                  Dist. Bhuj – Kutch, Gujarat. 370 201
                </p>
              ),
            },
          ].map((item, i) => (
            <motion.div
              className="contact-info-card"
              key={i}
              variants={{
                hidden: {
                  opacity: 0,
                  y: 45,
                },
                visible: {
                  opacity: 1,
                  y: 0,
                },
              }}
              transition={{
                duration: 0.7,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{
                y: -6,
              }}
            >

              {/* ICON */}
              <motion.div
                className="contact-icon-box"
                whileHover={{
                  rotate: 6,
                  scale: 1.08,
                }}
                transition={{ duration: 0.3 }}
              >
                {item.icon}
              </motion.div>

              {/* CONTENT */}
              <div className="contact-info-content">

                <h4 className="card-heading">
                  {item.title}
                </h4>

                {item.content}

              </div>

            </motion.div>
          ))}

        </motion.div>

        {/* MAP */}
        <motion.div
          className="contact-map"
          initial={{
            opacity: 0,
            y: 50,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            delay: 0.35,
            duration: 0.9,
          }}
          viewport={{ once: true }}
          whileHover={{
            scale: 1.01,
          }}
        >

          <iframe  
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3667.3762627568594!2d70.12664591128585!3d23.192954478967312!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3950bf66af494bff%3A0x42aa2cc7f82fb486!2sGurukrupa%20Wood%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1779078965048!5m2!1sen!2sin" 
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="map"
          ></iframe>

        </motion.div>

      </motion.div>

      {/* RIGHT */}
      <motion.div
        className="contact-form-wrapper"
        initial={{ opacity: 0, x: 70 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{
          duration: 0.9,
          ease: [0.22, 1, 0.36, 1],
        }}
        viewport={{ once: true, amount: 0.2 }}
      >

        {/* SUBHEADING */}
        <motion.h3
          className="section-subheading"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          GET IN TOUCH
        </motion.h3>

        {/* HEADING */}
        <motion.h2
          className="section-heading"
          initial={{ opacity: 0, y: 35 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.15,
            duration: 0.75,
          }}
          viewport={{ once: true }}
        >
          Send us a Message
        </motion.h2>

        {/* TEXT */}
        <motion.p
          className="section-text form-desc"
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.3,
            duration: 0.7,
          }}
          viewport={{ once: true }}
        >
          Fill out the form and our team will
          get back to you.
        </motion.p>

        {/* FORM */}
        <motion.form
          className="contact-form"
          onSubmit={handleSubmit}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.08,
              },
            },
          }}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
        >
<div className="form-grid">

  {[
    {
      label: "FULL NAME",
      name: "name",
      type: "text",
    },
    {
      label: "COMPANY NAME",
      name: "companyName",
      type: "text",
    },
    {
      label: "PHONE NUMBER",
      name: "phoneNumber",
      type: "tel",
    },
    {
      label: "EMAIL ADDRESS",
      name: "email",
      type: "email",
    },
  ].map((field, i) => (

    <motion.div
      className="form-group"
      key={i}
      variants={{
        hidden: {
          opacity: 0,
          y: 25,
        },
        visible: {
          opacity: 1,
          y: 0,
        },
      }}
      transition={{ duration: 0.5 }}
    >

      <label>
        {field.label} *
      </label>

      <motion.input
        type={field.type}
        name={field.name}
        value={formData[field.name]}
        onChange={handleChange}

        placeholder={`Enter ${field.label
          .toLowerCase()
          .split(" ")
          .map(
            word =>
              word.charAt(0).toUpperCase() +
              word.slice(1)
          )
          .join(" ")}`}

        whileFocus={{
          scale: 1.01,
        }}
      />

    </motion.div>

  ))}

</div>

          {/* SUBJECT */}
          <motion.div
            className="form-group"
            variants={{
              hidden: {
                opacity: 0,
                y: 25,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
          >

            <label>SUBJECT *</label>

            <motion.input
              type="text"
              placeholder="Enter Message Subject"
              name="subject"
              whileFocus={{
                scale: 1.01,
              }}
              value={formData.subject}
              onChange={handleChange}

            />

          </motion.div>

          {/* MESSAGE */}
          <motion.div
            className="form-group"
            variants={{
              hidden: {
                opacity: 0,
                y: 25,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
          >

            <label>MESSAGE *</label>

            <motion.textarea
              rows="6"
              name="message"
              placeholder="Enter your Message here"
              whileFocus={{
                scale: 1.01,
              }}
              value={formData.message}
              onChange={handleChange}

            ></motion.textarea>

          </motion.div>

          {/* BUTTON */}
          <motion.button
            type="submit"
            disabled={loading}
            className="green-btn"
            initial={{
              opacity: 0,
              scale: 0.9,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              delay: 0.4,
              duration: 0.5,
            }}
            viewport={{ once: true }}
            whileHover={{
              scale: 1.05,
              y: -2,
            }}
            whileTap={{ scale: 0.97 }}
          >
              {loading ? "Sending..." : "Send Message"}
          </motion.button>

        </motion.form>

      </motion.div>

    </div>

  </div>
             <ToastContainer
    position="top-right"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={true}
    closeOnClick
    pauseOnHover
    theme="light"
  />
</section>
        </>
    )
}
export default Contact;